import React, { useEffect, useState } from "react"
import "../../../styles/tellus-starter.scss"
import "../../../styles/tellus-starter.css"
import Slider from "rc-slider"
import { Input, List } from "reactstrap"
import { RATING_BOXES,checkAccess } from "../../../helper"
import WritingTips from "../../../asst/writting-tips.svg"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from "react-router-dom";


export default function NewTellUsStarter(props) {
  let {
    settings,
    attributeValue,
    setRequiredAttributes,
    setSliderValue,
    sliderValue,
    answer,
    setAnswer,
    errorAttribute,
    setErrorAttribute,
    ordersData,
    orderProductIndex,
    setAttribute,
    attributes,
    onTitleChange,
    setisTyped,
    onDescriptionChange,
    data,
    isEdit,
    starReview,
    onAttributeSelect,
    setReviewCheck,
    setAttributeAnswerMultipleValue,
    item,
  } = props
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const xToken = searchParams.get("merchantId");  
  console.log("🚀 ~ NewTellUsStarter ~ xToken:", xToken)
  // const [attributeValue, setAttribute] = useState([])
  const [answerss, setAnswerss] = useState([])
  const [answerss2, setAnswerss2] = useState([...answerss])
  const [activeValue, setActiveValues] = useState({})
  const [activeSingleValue, setActiveSingleValues] = useState(null)
  const [selectedOption, setSelectedOption] = useState("")
  const [modal, setModal] = useState(false)

  const toggle = () => {
    console.log("Toggle function called. Modal state before toggle:", modal)
    setModal(!modal)
  }

  const setAttributes = (attribute, answer, isMultiple = false) => {
    console.log("attributeValue", attribute)
    console.log(answer, "thisissetting")
    console.log(data.attributes, "thisissettingattributes")
    console.log(attributes, "this Is attributes side")
    console.log(attributeValue, "this Is attributeValue side")
    console.log(onDescriptionChange, "onDescriptionChangeonDescriptionChange")

    if (isMultiple) {
      const attributeIndex = attributeValue.findIndex(
        (item) => item._id === attribute._id
      )

      if (attributeIndex !== -1) {
        // Attribute already exists, so add to its selectedAnswer array if it's not already present
        const existingAnswers = attributeValue[attributeIndex].selectedAnswer
        const answerExists = existingAnswers.some(
          (ans) => ans._id === answer._id
        )

        if (!answerExists) {
          attributeValue[attributeIndex].selectedAnswer.push(answer)
        } else {
          attributeValue[attributeIndex].selectedAnswer =
            existingAnswers.filter((ans) => ans._id !== answer._id)
        }
      } else {
        attributeValue.push({
          ...attribute,
          selectedAnswer: [answer],
        })
      }
    } else {
      if (
        attributeValue.findIndex((item) => item._id === attribute._id) !== -1
      ) {
        attributeValue.splice(
          attributeValue.findIndex((item) => item._id === attribute._id),
          1
        )
      }
      attributeValue.push({ ...attribute, selectedAnswer: answer })
      if (attributeValue) {
        console.log(attributeValue, "selectedAnswerAnswer")
      }
      if (attributeValue.selectedAnswer && attributeValue.widgetType === 6) {
        setAttributeAnswerMultipleValue(false)
      }
    }
    setAttribute(attributeValue)
    setRequiredAttributes(false)
    onAttributeSelect(attributeValue)
    console.log("attributeValue--->", attributeValue)
  }

  useEffect(() => {
   
      if (attributes && isEdit) {
        attributes?.map((item) => {
          if (item.widgetType === 2) {
            console.log("herjkhekrj", item)
            setAttributes(
              item,
              {
                value: item?.selectedAnswer?.value,
                label: item?.selectedAnswer?.label,
              },
              false
            )
          }
          if (item.widgetType === 3) {
            console.log("herjkhekrj", item)
            setAttributes(
              item,
              {
                value: item?.selectedAnswer?.value,
                label: item?.selectedAnswer?.label,
              },
              false
            )
            setActiveSingleValues(item?.selectedAnswer?.value)
          }
          if (item.widgetType === 6) {
            console.log("herjkhekrj111", item)
            let indexes = []
            item?.selectedAnswer?.map((subItem) => {
              console.log("herjkhekrj11122", subItem)
              let index = item?.answers?.findIndex(
                (item) => item?.value === subItem?.value
              )
              console.log("herjkhekrj11122", index)
              indexes.push(index)
              setAttributes(item, subItem, true)
            })
            console.log("herjkhekrj11122final", indexes)
            setAnswerss2(indexes)
          }
          if (item.widgetType === 7) {
            console.log("herjkhekrjwqwq1321", item?.selectedAnswer)
            setSelectedOption(item?.selectedAnswer?.value)
            setAttributes(
              item,
              {
                value: item?.selectedAnswer?.value,
                label: item?.selectedAnswer?.value,
              },
              false
            )
          }
          if (item.widgetType === 8) {
            console.log("herjkhekrjwqwq", item?.selectedAnswer)
            setActiveValues((prev) => ({
              ...prev,
              [item?._id]: item?.selectedAnswer?.value,
            }))
            setAttributes(
              item,
              {
                value: item?.selectedAnswer?.value,
                label: item?.selectedAnswer?.label,
              },
              false
            )
          }
        })
      }
    
  }, [attributes])

 
  console.log(data?.item?.title, "data?.item?.title")
  return (
    <>
      <div style={{ position: "relative" }} className="rcf-modal-open">
        {xToken === "shoeboxpk.myshopify.com" ? "" : (
        <>
          <div>
              <input
                className="input-field-rcf-review rcf-title-input"
                name="title"
                type="text"
                style={{ color: settings?.fontColor ?? "#000" }}
                value={data?.title}
              placeholder={`${
                settings?.reviewPageTitle?.text ?? "Give your review a title"
              }`}
              onChange={(e) => {
                setisTyped(true)
                const inputValue = e.target.value
                console.log("e.target.value====here", e.target.value == "", inputValue)
                if (inputValue.length > 60) {
                  // Truncate the input if it exceeds 30 characters
                  e.target.value = inputValue.slice(0, 60)
                } else {

                }
                // if (e.target.value == "") setErrorAttribute(true)
                // else {
                //   setErrorAttribute(false)
                onTitleChange(e)
                // }
              }}
            ></input>
            
            <div className="description-rcf-text">
              <p className="text-field-count">
                {data?.title?.length ?? 0}
                /60
              </p>
            </div>
          </div>
          <div
            style={{ position: "absolute", top: "10px", right: "10px" }}
            onClick={toggle}
          >
            <img src={WritingTips} alt="WritingTips" />
          </div>
        </>
        )}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <div className="d-flex gap-2">
              <img src={WritingTips} alt="WritingTips" />
              <div className="writing-res-tips">Writing Tips</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div>
              <div style={{marginLeft:"3px", fontSize:"20px"}}>&#9989; Do</div>
              <div style={{marginTop:"3px", color:"#464646"}}>
                <List>
                  <li>Share your honest experience—good, bad, or neutral.</li>
                  <li>Be helpful for others considering the product.</li>
                  <li>Highlight specific details about the product value.</li>
                  <li>Use examples to add clarity to your feedback.</li>
                  <li>Keep it concise, focused, and easy to read.</li>
                </List>
              </div>

              <div style={{marginLeft:"3px", fontSize:"20px"}}>&#x274C; Don't</div>
              <div style={{marginTop:"3px", color:"#464646"}}>
                <List>
                  <li>Use inappropriate or offensive language.</li>
                  <li>Add unrelated links or promotions.</li>
                  <li>Include sensitive personal information.</li>
                  <li>Make exaggerated or false claims.</li>
                  <li>Copy content from other reviews.</li>
                </List>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>

      {/* <p>{starReview && "Please enter title"}</p> */}
      <div className="textarea-main-div">
        {ordersData ? (
          <textarea
            name="tellus"
            id="tellus-starter"
            cols="30"
            rows="10"
            className={`input-field-rcf-description ${
              errorAttribute ? "error" : ""
            }`}
            style={{ color: settings?.fontColor ?? "#000" }}
            value={data?.description}
            placeholder={
              settings?.description?.text
                ? settings?.description?.text?.replace("{product_name}", "") +
                  `${
                    settings?.description?.text?.includes("{product_name}") &&
                    item &&
                    item?.title
                      ? item?.title
                      : ``
                  }`
                : `Share Your Experience About ${
                    item
                      ? ordersData[0]?.products[orderProductIndex - 1]?.title
                      : ordersData[0]?.products[orderProductIndex - 1]?.title
                  }`
            }
            onChange={(e) => {
              setisTyped(true)
              const inputValue = e.target.value
              if (inputValue.length > 500) {
                // Truncate the input if it exceeds 500 characters
                e.target.value = inputValue.slice(0, 500)
              } else {
                if (inputValue.length > 0) {
                  setReviewCheck(true)
                } else if (inputValue === "") {
                  setReviewCheck(false)
                }
                onDescriptionChange(e)
                setErrorAttribute(false)
              }
            }}
          ></textarea>
        ) : (
          <textarea
            name="tellus"
            id="tellus-starter"
            cols="30"
            rows="10"
            className={`input-field-rcf-description ${
              errorAttribute ? "error" : ""
            }`}
            style={{ color: settings?.fontColor ?? "#000" }}
            placeholder={
              settings?.description?.text
                ? settings?.description?.text?.replace("{product_name}", "") +
                  `${
                    settings?.description?.text?.includes("{product_name}") &&
                    data &&
                    data?.item?.title
                      ? data?.item?.title
                      : ``
                  }`
                : `Share Your Experience About ${
                    data ? data?.item?.title : data?.item?.title
                  }`
            }
            onChange={(e) => {
              setisTyped(true)
              const inputValue = e.target.value
              if (inputValue.length > 500) {
                // Truncate the input if it exceeds 500 characters
                e.target.value = inputValue.slice(0, 500)
              } else {
                if (inputValue.length > 0) {
                  setReviewCheck(true)
                } else if (inputValue === "") {
                  setReviewCheck(false)
                }
                onDescriptionChange(e)
                setErrorAttribute(false)
              }
            }}
          ></textarea>
        )}
        <div className="description-rcf-text">
          <p className="text-field-count">
            {data?.description?.length ?? 0}
            /500
          </p>
        </div>
      </div>
      <div
        className=" rcf-tell-us-container"
        style={{
          color: settings?.fontColor ?? "#000",
          "--rate-background": settings?.SelectionColor ?? "#fff",
          "--select-hover-color": settings?.SelectionColor ?? "#0ABAAF",
          "--primary-color": settings?.SelectionColor ?? "#0ABAAF",
          "--select-background-color": settings?.SelectionColor ?? "#0ABAAF",
          "--select-font-color": settings?.SelectionFontColor ?? "#fff",
          "--font-color": settings?.fontColor ?? "#000",
        }}
      >
        <div
          className="tell-us-popup-content"
          style={{ width: "100% important" }}
        >
          <div
            className="textarea-details"
            style={{
              color: settings?.fontColor ?? "#000",
            }}
          >
            {checkAccess(
          "attributeRatings",
            <div className="extra-details tell-us-new-rcf">
              {attributes?.map((attribute) => {
                //recomend product type 2
                if (attribute?.widgetType === 2) {
                  return (
                    <div className="health-concerns pt-4">
                      <p
                        className="description recommended-products-heading"
                        style={{
                          color: settings?.fontColor ?? "#000",
                        }}
                      >
                        {attribute?.question}
                        <span
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {attribute?.required && "*"}
                        </span>
                        <span className="single-choose-select">Choose 1</span>
                      </p>
                      <div
                        className="health-buttons my-rcf-selected-div"
                        style={{
                          color: settings?.fontColor ?? "#000",
                        }}
                      >
                        {[
                          { label: "Yes", value: "Yes" },
                          { label: "No", value: "No" },
                        ]?.map((ans) => (
                          <button
                            className={`select-btn-rcf ${
                              ans.value === answer[attribute?.widgetType]
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              setAttributes(attribute, ans, false)
                              setAnswer({
                                ...answer,
                                [attribute?.widgetType]: ans.value,
                              })
                            }}
                          >
                            {ans.value}
                          </button>
                        ))}
                      </div>
                    </div>
                  )
                }
                //========================Number Selection =============
                else if (attribute?.widgetType === 3) {
                  return (
                    <div
                      className="effectiveness-helpful number-selection-main-div"
                      style={{ width: "100%" }}
                    >
                      <div className="effectiveness" style={{ width: "100%" }}>
                        <span
                          className="description recommended-products-heading new-rcf-main-heading"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {attribute?.question}
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                              fontSize: "16px",
                            }}
                          >
                            {attribute?.required && "*"}
                          </span>
                        </span>
                        <span className="single-choose-select">Choose 1</span>
                        <div
                          className="effectiveness-no"
                          style={{
                            width: "100%",
                          }}
                        >
                          {RATING_BOXES?.map((item) => (
                            <span
                              onClick={() => {
                                console.log(
                                  "color======",
                                  settings?.SelectionFontColor ?? "#000",
                                  "backgroundColor======",
                                  item.value === answer[attribute?.widgetType]
                                    ? settings?.SelectionColor
                                    : "#fff",
                                  "border=====",
                                  item.value === answer[attribute?.widgetType]
                                    ? settings?.SelectionColor
                                    : ""
                                )
                                setAttributes(attribute, item, false)
                                setAnswer({
                                  ...answer,
                                  [attribute?.widgetType]: item.value,
                                })
                                setActiveSingleValues(item.value)
                              }}
                              // className={`select-choice-btn-rcf c-pointer effectiveness-item ${
                              //   answer[attribute?.widgetType] === item.value
                              //     ? "active"
                              //     : ""
                              // }`}
                              className={`select-choice-btn-rcf c-pointer effectiveness-item ${
                                activeSingleValue === item.value ? "active" : ""
                              }`}
                              style={{}}
                              key={item.value}
                            >
                              {item.label}
                            </span>
                          ))}
                        </div>
                        <div
                          className="rcf-heading-optins"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          <span className="rcf-heading-optins">
                            {attribute?.answers?.[0]?.label}
                          </span>
                          <span className="rcf-heading-optins">
                            {attribute?.answers?.[1]?.label}
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                }
                //===================Option Bar WidgetType4=======
                else if (attribute?.widgetType === 4) {
                  return (
                    <div className="attribute-five attribute-five-new-rcf">
                      <div>
                        <p
                          className="description recommended-products-heading new-rcf-main-heading"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {attribute?.question}
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.required && "*"}
                          </span>
                          <span className="single-choose-select">Choose 1</span>
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Slider
                            className="slider-new-rcf"
                            min={0}
                            defaultValue={null}
                            marks={{
                              0: attribute?.answers?.[0]?.label,
                              50: attribute?.answers?.[1]?.label,
                              100: attribute?.answers?.[2]?.label,
                            }}
                            step={50}
                            included={false}
                            value={sliderValue}
                            // ref={sliderRef}
                            onChange={(value, label) => {
                              // Your onChange logic here
                              if (value === 0) {
                                value = attribute?.answers?.[0]?.value
                                label = attribute?.answers?.[0]?.label
                              }
                              if (value === 50) {
                                value = attribute?.answers?.[1]?.value
                                label = attribute?.answers?.[1]?.label
                              }
                              if (value === 100) {
                                value = attribute?.answers?.[2]?.value
                                label = attribute?.answers?.[2]?.label
                              }

                              console.log(value, "asdasdasd")

                              console.log("attribute---?", value)
                              setAttributes(
                                attribute,
                                { value: value, label: label },
                                false
                              )
                              setSliderValue(value)
                            }}
                            style={{
                              background:
                                attribute?.value ===
                                attribute?.answers?.[1]?.value
                                  ? "#ccc"
                                  : undefined,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
                //=================center-Option_bar==============
                else if (attribute?.widgetType === 5) {
                  return (
                    <div
                      className="attribute-four"
                      style={{
                        padding: "0 0 30px 0px",
                      }}
                    >
                      <div>
                        <p
                          className="description recommended-products-heading new-rcf-main-heading"
                          style={{ color: settings?.fontColor ?? "#000" }}
                        >
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          ></span>
                          {attribute?.question}
                          {attribute?.required && "*"}
                          <span className="single-choose-select">Choose 1</span>
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Slider
                            className="center-bar-new-rcf"
                            style={{ width: "96% !important" }}
                            min={0}
                            defaultValue={null}
                            marks={{
                              0: attribute?.answers?.[0]?.label,
                              50: attribute?.answers?.[1]?.label,
                              100: attribute?.answers?.[2]?.label,
                            }}
                            step={50}
                            included={false}
                            // value={sliderValue}
                            onChange={(value, label) => {
                              if (value === 0) {
                                value = attribute?.answers?.[0]?.value
                                label = attribute?.answers?.[0]?.label
                              }
                              if (value === 50) {
                                value = attribute?.answers?.[1]?.value
                                label = attribute?.answers?.[1]?.label
                              }
                              if (value === 100) {
                                value = attribute?.answers?.[2]?.value
                                label = attribute?.answers?.[2]?.label
                              }
                              setAttributes(
                                attribute,
                                {
                                  value: value,
                                  label: label,
                                },
                                false
                              )
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
                // =====================Mutiple Selection ====================
                else if (attribute?.widgetType === 6) {
                  return (
                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p
                          className="recommended-products-heading new-rcf-main-heading"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {" "}
                          {attribute?.question}
                          <span>{attribute?.required && "*"}</span>
                        </p>
                        <div style={{ paddingTop: "8px" }}>
                          <span className="single-choose-select">
                            Choose 1 or more
                          </span>
                        </div>
                      </div>
                      <div className="rcf-div-multi-option">
                        {attribute?.answers?.map((answers, index) => (
                          <button
                            key={index}
                            className={`select-multi-btn-rcf ${
                              answerss2?.includes(answers?._id) ? "active" : ""
                            }`}
                            onClick={() => {
                              console.log("asdasda", answers)
                              setAttributes(attribute, answers, true)
                              if (answerss2?.includes(answers?._id)) {
                                answerss2.splice(answerss2.indexOf(answers?._id), 1)
                              } else answerss2.push(answers?._id)
                              console.log("asdasdaanswerss2", answerss2)
                              setAnswerss(answerss2)
                              setAnswer({
                                ...answer,
                                [attribute?.widgetType]: answers.value,
                              })
                              setAnswerss("")
                              console.log(
                                "indexx==",
                                answerss2?.includes(index)
                              )
                              console.log("multi=>", answerss2)
                            }}
                          >
                            {answers.value}
                          </button>
                        ))}
                      </div>
                    </div>
                  )
                } else if (attribute?.widgetType === 7) {
                  return (
                    <div
                      className="gender"
                      style={{
                        color: settings?.fontColor ?? "#000",
                      }}
                    >
                      <label
                        className="recommended-products-heading new-rcf-main-heading"
                        htmlFor="dropdown"
                      >
                        <span
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        ></span>
                        {attribute?.question}
                        {attribute?.required && "*"}
                      </label>
                      <span className="single-choose-select">Choose 1</span>
                      <Input
                        className="dropDown-select"
                        type="select"
                        name="drop"
                        id="dropdowm"
                        value={selectedOption}
                        style={{ color: settings?.fontColor ?? "#000" }}
                        onChange={(e) => {
                          const selectedValue = e.target.value
                          setSelectedOption(selectedValue)
                          attribute.selectedAnswer = selectedValue
                          setAttributes(
                            attribute,
                            {
                              value: e.target.value,
                              label: e.target.value,
                            },
                            false
                          )
                        }}
                      >
                        <option
                          disabled
                          value=""
                          selected
                          className="dropdown-selected-new-rcf"
                        >
                          Choose Option
                        </option>
                        {attribute?.answers?.map((answer) => (
                          <option value={answer.value}>{answer.label}</option>
                        ))}
                      </Input>
                    </div>
                  )
                }
                ///=========================single select======================
                else if (attribute?.widgetType === 8) {
                  return (
                    <div>
                      <div>
                        <label
                          className="recommended-products-heading new-rcf-main-heading"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {attribute?.question}
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.required && "*"}
                          </span>
                        </label>
                        <span className="single-choose-select">Choose 1</span>
                      </div>
                      <div
                        className="rcf-div-multi-option"
                        style={{
                          color: settings?.fontColor ?? "#000",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {attribute?.answers?.map((answer) => (
                          <div className="d-flex">
                            <div style={{ paddingTop: "1px" }}>
                              <input
                                type="radio"
                                id={`radio-${answer.value}`}
                                className={`input-radio-btn select-multi-btn-rcf ${
                                  activeValue === answer.value ? "active" : ""
                                }`}
                                name={`radio-${attribute?._id}`}
                                value={answer?.value}
                                checked={
                                  activeValue[attribute?._id] === answer?.value
                                }
                                onChange={() => {
                                  setAttributes(
                                    attribute,
                                    {
                                      value: answer?.value,
                                      label: answer?.label,
                                    },
                                    false
                                  )
                                  // setActiveValues(answer.value)
                                  setActiveValues((prev) => ({
                                    ...prev,
                                    [attribute?._id]: answer?.value,
                                  }))
                                }}
                              />
                            </div>
                            <label
                              style={{ paddingLeft: "20px" }}
                              htmlFor={`radio-${answer.value}`}
                            >
                              {answer?.value}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                } else return <div></div>
              })}
            </div>
           )}
          </div>
        </div>
      </div>
    </>
  )
}
